import { imageDataFromVideo } from "./imageData";

class Camera {
  constructor(videoEl, stream) {
    this.videoEl = videoEl;
    this.stream = stream;
  }

  stop() {
    this.stream.getTracks().forEach(track => track.stop());
  }

  captureFrame() {
    return imageDataFromVideo(this.videoEl);
  }
}

export default async function(constraints, videoEl) {
  const stream = await navigator.mediaDevices.getUserMedia(constraints);

  videoEl.onloadeddata = event => {
    console.log(
      "Yay! The readyState just increased to  " +
        "HAVE_CURRENT_DATA or greater for the first time.",
      event
    );
  };

  if (videoEl.srcObject !== undefined) {
    videoEl.srcObject = stream;
  } else if (videoEl.mozSrcObject !== undefined) {
    videoEl.mozSrcObject = stream;
  } else if (window.URL.createObjectURL) {
    videoEl.src = window.URL.createObjectURL(stream);
  } else if (window.webkitURL) {
    videoEl.src = window.webkitURL.createObjectURL(stream);
  } else {
    videoEl.src = stream;
  }

  return new Camera(videoEl, stream);
}
